const getters = {
    columnsFilters: (state) => state.columnsFilters,
    columnFiltersByKey: (state) => (key) => state.columnsFilters[key]?.columnFilters,
}

export default getters